import angular from 'angular';
import ProductGrid from '../../cmsCore/ProductsModules/ProductsGrid/ProductsGrid';

export default angular.module('cms.products.list', [ProductGrid])
    .component('productsListPage', {
        template: require('./templates/products.html'),
        bindings: {
            $transition$: '<'
        },
        controller: function (gettextCatalog, toastr, CONFIG, $state, ExportService) {
            /** @ngInject */

            this.$onInit = () => {
                this.initialParams = this.$transition$.params();
            };

            this.onParamsChange = params => {
                delete params.page;
                $state.go('.', params, {
                    location: 'replace'
                });
            };

            this.addProduct = () => {
                $state.go('productsAdd', {
                    returnState: {
                        name: 'products',
                        params: angular.copy($state.params)
                    }
                });
            }


            this.onPageChange = page => {
                if(page === 0) {
                    return;
                }
                $state.go('.', {page:  page !== 1 ? page : undefined}, {
                    location: 'replace'
                });
            };

            this.exportUrl = () => {
                return ExportService.getUrl('products');
            };

        }
    }).name;




// WEBPACK FOOTER //
// ./src/cmsPages/Products/ProductsListPage.js